import React, { useCallback, useState } from "react";

import { CustomProjectPropertyValueResponse } from "../../../../../api-models/response/CustomProjectPropertyValueResponse";
import {
  DataSection,
  SubSection,
} from "../../../../../components/data-components/sections/DataSections";
import { CustomPropertiesModel } from "../../../../../services/organization/ProjectPropertyStorage";
import DisplayCustomProperty from "../../../../../components/data-components/DisplayCustomProperty";
import {
  CustomProjectPropertyValue,
  CustomProjectPropertyValueModel,
} from "../../../../../components/data-components/CustomProjectPropertyValue";

interface CustomProjectPropertiesProps {
  values: CustomProjectPropertyValueResponse[];
}

interface Column {
  id: number;
  properties: CustomProjectPropertyValueResponse[];
}

export function CustomProjectPropertiesSection(props: CustomProjectPropertiesProps) {
  const { values } = props;

  const [customPropertiesModel] = useState(() => CustomPropertiesModel.create({}));
  const columns: Column[] = customPropertiesModel.getMappedColumns(values);

  const customProjectPropertyValueState = useCallback(
    (property: CustomProjectPropertyValueResponse): CustomProjectPropertyValue =>
      CustomProjectPropertyValueModel.create(
        {
          label: property.label,
          value: property.value,
          columnId: property.columnId,
          index: property.index,
          type: property.type,
        },
        {}
      ),
    []
  );

  return (
    <DataSection labelKey="general.projects.custom-details">
      {columns.map((column) => {
        return (
          <SubSection key={column.id}>
            {column.properties.map((property) => {
              return (
                <DisplayCustomProperty
                  key={`${property.columnId}-${property.index}`}
                  customProjectPropertyValueState={customProjectPropertyValueState(property)}
                />
              );
            })}
          </SubSection>
        );
      })}
    </DataSection>
  );
}
